import script from "./Dots.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dots.vue?vue&type=script&lang=ts&setup=true"

import "./Dots.vue?vue&type=style&index=0&id=22b6a5a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b6a5a0"]])

export default __exports__